import { Component, OnInit, Injectable } from '@angular/core';
import { ListResponse } from 'src/models/com.enersol.directshopping.ws.rest.model/ListResponse';
import { HttpClientEnersolService } from 'src/services/http-client-enersol.service';
import { GlobalService } from 'src/services/global';
import { ValidationsService } from 'src/services/validations.service';
import { ErrorService } from 'src/services/error.service';
import { HistoricoProductoPricing } from 'src/models/com.enersol.directshopping.dal.entidad/HistoricoProductoPricing'

@Injectable()
export class HistorialRevisionPreciosComponent {

  constructor(
    private httpClientEnersolService: HttpClientEnersolService,
    private globalEnersolService: GlobalService,
    private validationEnersolService: ValidationsService,
    private errorService: ErrorService,
  ) { }

  /* FUNCIONES QUE HACEN PETICIONES A LOS SERVICIOS */

  /**
  * Función que hace la petición del servicio de todos los productos en pricing en el historico
  * @returns ListResponse<ProductoPricing>
  * @author kjimenez
  */
  async getHistoricoProductosPricing(): Promise<ListResponse<HistoricoProductoPricing>> {
    let respuesta: ListResponse<HistoricoProductoPricing>;
    try {
      let promiseResponse = await this.httpClientEnersolService.httpGet('HistoricoPricing/all');
      respuesta = <ListResponse<HistoricoProductoPricing>>promiseResponse;
    }
    catch (error) {
      console.log(error.message);
      respuesta = new ListResponse<HistoricoProductoPricing>(false);
      respuesta.addError('code', 'techMessage', 'userMessage');
    }
    finally {
      return respuesta;
    }
  }

}
